module.exports = __webpack_public_path__ + "img/icon-user.svg?7c5dc91493d86db11c9dbbbbcebab156";